import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostListener,
  output,
  OnChanges,
} from '@angular/core';
import { Contact } from '../models/contact.model';
import { UserProfilePictureComponent } from '../user-profile-picture/user-profile-picture.component';
import { ContactsStore } from '../../stores/contacts.store';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-contacts-autocomplete',
  templateUrl: './contacts-autocomplete.component.html',
  imports: [UserProfilePictureComponent],
})
export class ContactsAutocompleteComponent implements OnInit, OnDestroy, OnChanges {
  @Input() query: string = '';
  selectContact = output<Contact>();

  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;

  show = false;

  private contactsStore = new ContactsStore();
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  get contacts(): Contact[] {
    return this.contactsStore.entities();
  }

  ngOnInit() {
    this.searchSubject.pipe(debounceTime(200), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe((query) => {
      console.log(query);
      if (query && query.length > 1) {
        this.contactsStore.standaloneSearchContacts({ query, pageSize: 3, pageIndex: 0 });
        this.show = true;
      }
    });
  }

  ngOnChanges() {
    this.searchSubject.next(this.query);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSelect(contact: Contact) {
    this.selectContact.emit(contact);
    this.show = false;
  }

  getImageUrl(contact: Contact): string {
    return environment.api + 'User/get-public-profile-picture?userId=' + contact.id;
  }

  trackById(index: number, contact: Contact) {
    return contact.id;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (
      this.show &&
      this.dropdownContainer?.nativeElement &&
      !this.dropdownContainer.nativeElement.contains(event.target)
    ) {
      this.show = false;
    }
  }
}
